import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormInputComponent } from '@ftr/forms'
import { ButtonComponent, IconComponent } from '@ftr/foundation'
import { AppearancesEditComponent } from '~app/features/appearances/appearances-edit/appearances-edit.component'
import { AppearancesComponent } from '~app/features/appearances/appearances/appearances.component'

@NgModule({
  declarations: [AppearancesEditComponent, AppearancesComponent],
  imports: [ButtonComponent, CommonModule, FormInputComponent, IconComponent],
  exports: [AppearancesEditComponent, AppearancesComponent],
})
export class AppearancesModule {}
